fragment AccountSearchResultByType on Account {
    id
    name
    description
    initials
    htmlUrlPath
    avatarUrl
    primaryContact {
        id
        name
    }
    primaryAddressRegion
    postalAddresses {
        primary {
            value {
                city
                postalCode
            }
        }
    }
    phones {
        primary {
            value {
                id
                numberFormatted
            }
        }
    }
}
